<template>
    <div class="form-popup">
        <button type="button" class="popup-close icon-close" @click="$emit('onClose')"></button>
        <template v-if="!showThanks">
            <h2 v-text="translate('form_title')"></h2>
            <div class="form">
                <div v-if="!isSubmitError">
                    <div class="input input--text">
                        <label :class="{'show': form.name !== ''}" v-text="translate('form_name')"></label>
                        <input type="text" name="name" :placeholder="translate('form_name')" v-model.trim="form.name" :class="{ 'is-error': $v.form.name.$error }">
                        <template v-if="$v.form.name.$error">
                            <p class="input__error-message" v-if="!$v.form.name.required" v-text="translate('form_required')"></p>
                        </template>
                    </div>
                    <div class="input input--text">
                        <label :class="{'show': form.description !== ''}" v-text="translate('form_description')"></label>
                        <textarea @input="autoResize" name="description" type="text" :placeholder="translate('form_description')" v-model.trim="form.description"></textarea>
                    </div>
                    <div class="input input--text">
                        <label :class="{'show': form.email !== ''}" v-text="translate('form_email')"></label>
                        <input type="email" name="email" :placeholder="translate('form_email')" v-model.trim="form.email" :class="{ 'is-error': $v.form.email.$error }">
                        <template v-if="$v.form.email.$error">
                            <p class="input__error-message" v-if="!$v.form.email.email" v-text="translate('form_wrong_email')"></p>
                            <p class="input__error-message" v-if="!$v.form.email.required" v-text="translate('form_required')"></p>
                        </template>
                    </div>
                    <div class="input input--text">
                        <label :class="{'show': form.restaurant !== ''}" v-text="translate('form_restaurant')"></label>
                        <input type="text" name="restaurant" :placeholder="translate('form_restaurant')" v-model.trim="form.restaurant">
                    </div>
                    <div class="input-submit-wrapper">
                        <div class="input input--submit">
                            <button type="button" class="btn" @click="submitForm" :class="{'is-loading': waiting}"><span v-text="translate('form_submit')"></span></button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h2 class="submit-error">{{submitError}}</h2>
                </div>
            </div>
        </template>
        <template v-else>
            <h2 v-html="translate('form_success')"></h2>
            <div class="input input--submit">
                <button type="button" class="btn" @click="resetForm"><span v-html="translate('form_add_more')"></span></button>
            </div>
        </template>
    </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import autoResize from "../helpers/autoResize.js";
import {translate} from "@/helpers/helpers";

export default {
    name: "form-popup",
    mixins: [autoResize],
    data() {
        return {
            isSubmitError: false,
            submitError: '',
            showThanks: false,
            waiting: false,
            rulesUrl: '/rules',
            form: {
                name : '',
                description : '',
                email : '',
                restaurant: ''
            },
        }
    },
    validations: {
        form: {
            name : { required },
            email : { email, required }
        }
    },
    methods: {
        translate: translate,
        resetForm() {
            this.form.name = '';
            this.form.description = '';
            this.form.email = '';
            this.form.restaurant = '';

            this.showThanks = false;
        },
        submitForm() {
            if(this.waiting) return;

            this.$v.form.$touch();

            if (this.$v.form.$invalid) {
                return;
            }

            this.waiting = true;

            this.axios.post('/api/send', {
                ...this.form
            }).then(result => (result.data)).then(data => {
                this.waiting = false;

                if(data.success === true) {
                    this.showThanks = true;
                }else{
                    this.isSubmitError = true;
                    this.submitError = data.message;
                }

            }).catch((e) => {
                this.waiting = false;
                alert('Coś poszło nie tak, spróbuj później')
            });
        }
    }
}
</script>

<style scoped>

</style>